import { apiEndpoint } from '../../config/app';
import createRestApiClient from '../utils/createRestApiClient';

export default () =>{
    const client = createRestApiClient().withConfig({ baseURL: apiEndpoint });
    return {
        getAll: () => client.request({
            method: 'GET',
            url: '/campaign'
        }),
        getPublic:(id) => client.request({
            method: 'GET',
            url: `/campaign/public/${id}`
        }),
        get: (id) => client.request({
            method: 'GET',
            url: `/campaign/${id}`
        }),
        remove: (campaign) => client.request({
            method: 'DELETE',
            url: `/campaign/${campaign.id}`
        }),
        update: (campaign) => client.request({
            method: 'PUT',
            url: `/campaign/${campaign.id}`,
            data : campaign
        }),
        create: (campaign) => client.request({
            method: 'POST',
            url: `/campaign/${campaign.id}`,
            data : campaign
        })
    };
};


// WEBPACK FOOTER //
// app/services/campaigns.js